import { render, staticRenderFns } from "./resign-record.vue?vue&type=template&id=0c9e2690&scoped=true&"
import script from "./resign-record.vue?vue&type=script&lang=ts&"
export * from "./resign-record.vue?vue&type=script&lang=ts&"
import style0 from "./resign-record.vue?vue&type=style&index=0&id=0c9e2690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e2690",
  null
  
)

export default component.exports